import { Option } from '../../../../general-types';

export const getOptionsByValues = <TOption extends Option<string>>(
  options: TOption[],
  values: TOption['value'][],
): TOption[] => {
  return options.filter((option) => values.includes(option.value));
};
